// @flow
import React from 'react';
import DefaultTheme from './theme';
import { PrimaryButton } from '../buttons';
/*::
import type { Node } from 'react';
import type { CardThemeType } from './theme';

export type Props = {|
  text: string,
  infoColor: string,
  infoLogoSrc: string,
  infoLogoAlt?: string;
  infoText: string,
  infoButtonText: string,
  infoButtonTo?: string,
  linkComponent?: Node;
  children?: React$Element<any>,
  theme?: CardThemeType,
|}
*/

var Card = function Card(_ref
/*: Props */
) {
  var text = _ref.text,
      infoColor = _ref.infoColor,
      infoLogoSrc = _ref.infoLogoSrc,
      _ref$infoLogoAlt = _ref.infoLogoAlt,
      infoLogoAlt = _ref$infoLogoAlt === void 0 ? '' : _ref$infoLogoAlt,
      infoText = _ref.infoText,
      infoButtonText = _ref.infoButtonText,
      _ref$infoButtonTo = _ref.infoButtonTo,
      infoButtonTo = _ref$infoButtonTo === void 0 ? '#' : _ref$infoButtonTo,
      children = _ref.children,
      _ref$linkComponent = _ref.linkComponent,
      linkComponent = _ref$linkComponent === void 0 ? 'a' : _ref$linkComponent,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme;
  return /*#__PURE__*/React.createElement(theme.CardImgItem, null, React.Children.only(children), /*#__PURE__*/React.createElement(theme.CardImgGradient, null), /*#__PURE__*/React.createElement(theme.CardImgText, null, text), /*#__PURE__*/React.createElement(theme.CardImgInfo, {
    infoColor: infoColor,
    className: "card-img-info"
  }, /*#__PURE__*/React.createElement(theme.CardImgInfoLogo, {
    src: infoLogoSrc,
    alt: infoLogoAlt,
    loading: "lazy"
  }), /*#__PURE__*/React.createElement(theme.CardImgInfoText, null, infoText), /*#__PURE__*/React.createElement(PrimaryButton, {
    href: infoButtonTo,
    linkComponent: linkComponent,
    theme: theme.CardImgInfoButton
  }, infoButtonText)));
};

export default Card;